import { Observable, of } from 'rxjs';

export class ThemesData {
  getthemes(url: string) {
    let result: any;
    result = [
      {
        theme: "Theme1", backgorund: "rgb(220 235 224)", foreground: "#162F29", ischecked: false, answerthemes: [{ Id: "theme1" }, { Id: "theme1" }]
      },
      {
        theme: "Theme2", backgorund: "rgb(226 220 252)", foreground: "#282CB1", ischecked: false, answerthemes: [{ Id: "theme2" }, { Id: "theme2" }]
      },
      {
        theme: "Theme3", backgorund: "#F0DFBD", foreground: "rgb(46, 144, 163)", ischecked: true, answerthemes: [{ Id: "theme3" }, { Id: "theme3" }]
      }
    ];
    return of(result); //return Observable of type 'result'
  }


  getsurveyresponsetheme(theme: string) {
    let result: any;
    switch (theme) {
      case "Theme1": result = [
        {
          theme: "Theme1", backgorund: "rgb(220 235 224)", foreground: "#162F29", ischecked: false, answerthemes: [{ Id: "theme1" }, { Id: "theme1" }]
        }
      ];
        break;
      case "Theme2": result = [
        {
          theme: "Theme2", backgorund: "rgb(226 220 252)", foreground: "#282CB1", ischecked: false, answerthemes: [{ Id: "theme2" }, { Id: "theme2" }]
        }
      ];
        break;
      case "Theme3": result = [
        {
          theme: "Theme3", backgorund: "#F0DFBD", foreground: "rgb(46, 144, 163)", ischecked: true, answerthemes: [{ Id: "theme3" }, { Id: "theme3" }]
        }
      ];
        break;
      default:
        result = [
          {
            theme: "Theme3", backgorund: "#F0DFBD", foreground: "rgb(46, 144, 163)", ischecked: true, answerthemes: [{ Id: "theme3" }, { Id: "theme3" }]
          }
        ];//default theme 1
    }
    return of(result); //return Observable of type 'result'
  }


}
